import {
  SHOW_LOADER,
  HIDE_LOADER,
  SET_RESPONSE_MODAL,
  SET_AGENT_STAFF_ID,
  SET_AGENT_TABLE_ID,
} from './types';

export const showLoader = () => ({
  type: SHOW_LOADER,
  payload: true,
});

export const hideLoader = () => ({
  type: HIDE_LOADER,
  payload: true,
});

export const setResponseModal = (payload) => ({
  type: SET_RESPONSE_MODAL,
  payload,
});

export const showErrorResponseModal = (payload) =>
  setResponseModal({
    error: true,
    success: false,
    message: payload.message || payload,
    show: true,
    title: payload.title,
    customAction: payload.action,
    customCallback: payload.callback,
  });

export const closeResponseModal = () =>
  setResponseModal({
    show: false,
    success: false,
    error: false,
    title: '',
    message: '',
    customAction: null,
    customCallback: null,
  });

export const showSuccessResponseModal = (payload) =>
  setResponseModal({
    error: false,
    success: true,
    message: payload.message || payload,
    show: true,
    title: payload.title,
    customAction: payload.action,
  });

export const setAgentStaffId = (payload) => ({
  type: SET_AGENT_STAFF_ID,
  payload,
});

export const setAgentTableId = (payload) => ({
  type: SET_AGENT_TABLE_ID,
  payload,
});
